// extracted by mini-css-extract-plugin
export default {"starRatingContainer":"star-rating-module__starRatingContainer__6sEsS","starItem":"star-rating-module__starItem__8GSZG"};